import React, {useCallback} from 'react';
import styles from './loyaltyCopy.module.scss';
import cn from 'classnames';
import { TouchableButton } from '@components/common/Touchable/index';
import { LABEL } from '../../veriables';
import { FormatLoyaltyPhoneNumber } from '@utility/helperFunction';

const LoyaltyLandingPage = ({
    seats = [], 
    serverAppTheme = {},
    deleteLoyalty,
    onClose,
    handleLoyaltyClick,
    viewOffersOnclick,
}) => {

    const handleDoneClick = useCallback((e) => {
        e.stopPropagation();
        e.preventDefault();
        onClose(false);
    }, [onClose]);

    return (
        <div className={styles.container}>
            <div className={cn('px-12', styles.content)}>
                {/* Table Header */}
                <div className={cn('row mx-0 fs_12 fw-400 py-12 px-3', styles.tHeader)}>
                    <div className={cn('text-left', styles.seatWidth)}>Seat</div>
                    <div className={cn('col-3 px-0 text-left')}>Guest Name</div>
                    <div className={cn('col-3 px-0 text-left')}>Account Number</div>
                </div>
                {/* Table Body */}
                <div className={styles.scrollBody}>
                    {seats?.map(seat => {
                        return(
                        <div key={seat?.number} className={cn('row mx-0 fs_14 fw-500 px-3 align-items-center mb-12', styles.tBody)}>
                            <div className={cn('text-left', styles.seatWidth)}>
                                <span className={styles.seatNumb}>{seat?.number}</span>
                            </div>
                            <div className={cn('col-3 px-0 text-left')}>{seat?.loyalty?.guestName}</div>
                            <div className={cn('col-3 px-0 text-left')}>{FormatLoyaltyPhoneNumber(seat?.loyalty?.displayAccountNumber)}</div>
                            <div className='col px-0 justify-content-end d-flex'>
                            {seat?.loyalty?
                                <TouchableButton
                                    className={cn('fs_14 fw-600 od-primary-btn-bg-color od-primary-btn-font-color',
                                    styles.loyaltyBtnPrimary,
                                    )}
                                    onClick={deleteLoyalty(seat?.id)}
                            >
                                {LABEL().OLLS_REMOVE}
                            </TouchableButton>
                            :
                            <div>
                            <TouchableButton
                                className={cn('fs_14 fw-600 mr-3 od-primary-btn-bg-color od-primary-btn-font-color',
                                styles.loyaltyBtnPrimary
                                )}
                                onClick={handleLoyaltyClick('signIn', seat?.id)}
                            >
                                {LABEL().OLLS_SIGN_IN}
                            </TouchableButton>
                            <TouchableButton
                                className={cn('fs_14 fw-600 od-primary-btn-bg-color od-primary-btn-font-color',
                                styles.loyaltyBtnPrimary
                                )}
                                onClick={handleLoyaltyClick('signUp', seat?.id)}
                            >
                                {LABEL().OLLS_SIGN_UP}
                            </TouchableButton>
                            </div>}
                            </div>
                        </div>
                        )
                    })}
                </div>
            </div>
            {/* Bottom Buttons */}
            <div className={cn('px-3 py-12 w-100 row mx-0 fs_24 fw-600 justify-content-center', styles.bottomBtns)} style={{backgroundColor: serverAppTheme?.popUp_bg}}>
                <TouchableButton
                    className={cn('mr-3 od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color fw-600',
                    styles.BtnBottomSecondary, styles.BtnBottom
                    )}
                    onClick={viewOffersOnclick}
                >
                    {LABEL().OLLS_VIEW_OFFERS}
                </TouchableButton>
                <TouchableButton
                    className={cn('od-primary-btn-bg-color od-primary-btn-font-color fw-600',
                        styles.BtnBottomPrimary, styles.BtnBottom
                    )}
                    onClick={handleDoneClick}
                >
                    {LABEL().OLLS_DONE}
                </TouchableButton>
            </div>
        </div>
    )

}

export default (React.memo(LoyaltyLandingPage));